const logoutChannel = new BroadcastChannel('user_logged_out')

logoutChannel.onmessage = () => window.location.reload()
window.userLoggedOut = () => logoutChannel.postMessage({})
